import { MealType } from "model/food/types"
import {
  IAIScanMeal,
  IAIScanNutritionFactMeal,
  IAIScanPackageMeal,
} from "model/food/types/AIScan.types"
import { IEdamaMeal } from "model/food/types/edama.types"

import { IMyMeal } from "model/food/types/myfood.types"
import { IOpenFoodFactMeal } from "model/food/types/openFoodFact.types"

export const isEdamaMeal = (meal: MealType): meal is IEdamaMeal => {
  return meal.source === "EDAMAM"
}

export const isMyMeal = (meal: MealType): meal is IMyMeal => {
  return meal.source === "MY_FOOD"
}

export const isAIScanMeal = (meal: MealType): meal is IAIScanMeal => {
  return meal.source === "AI_SCAN_MEAL"
}

export const isAIScanPackageMeal = (
  meal: MealType,
): meal is IAIScanPackageMeal => {
  return meal.source === "AI_SCAN_PACKAGE"
}

export const isAIScanNutritionFactsMeal = (
  meal: MealType,
): meal is IAIScanNutritionFactMeal => {
  return meal.source === "AI_SCAN_NUTRITION_FACTS"
}

export const isOpenFoodFactMeal = (
  meal: MealType,
): meal is IOpenFoodFactMeal => {
  return meal.source === "OPEN_FOOD_FACTS"
}

export const isNonIngredientMeal = (
  meal: MealType,
): meal is
  | IEdamaMeal
  | IAIScanPackageMeal
  | IAIScanNutritionFactMeal
  | IOpenFoodFactMeal => {
  return (
    isEdamaMeal(meal) ||
    isAIScanPackageMeal(meal) ||
    isAIScanNutritionFactsMeal(meal) ||
    isOpenFoodFactMeal(meal)
  )
}
